const EVM_ADDRESS_WITH_PREFIX_PATTERN = /^0x[a-fA-F0-9]{40}$/;
const BARE_EVM_ADDRESS_HEX_PATTERN = /^[a-fA-F0-9]{40}$/;

/** True when `address` is a standard Ethereum address (`0x` + 40 hex chars, or bare 40 hex chars). */
export function isEvmAddress(address: string | null | undefined): boolean {
  if (address == null) {
    return false;
  }
  const trimmed = address.trim();
  if (trimmed === '') {
    return false;
  }
  return EVM_ADDRESS_WITH_PREFIX_PATTERN.test(trimmed) || BARE_EVM_ADDRESS_HEX_PATTERN.test(trimmed);
}

/**
 * Ensures a valid EVM address is `0x`-prefixed for API submission.
 * Trims whitespace. Non-EVM / incomplete values are returned trimmed unchanged.
 */
export function normalizeEvmAddress(address: string): string {
  const trimmed = address.trim();
  if (BARE_EVM_ADDRESS_HEX_PATTERN.test(trimmed)) {
    return `0x${trimmed}`;
  }
  return trimmed;
}
